import React from "react";
import { Card, CardContent, Tabs, Tab, Stack, Divider } from "@mui/material";
import { Briefcase, MapPin, Hash, BarChart2, Calendar, Users, DollarSign, TrendingUp } from "react-feather";
import { SectionTitle, KvRow } from "./UiBits";

export default function DettagliAziendaCard({
  theme,
  cardSx,
  contentSx,
  tab,
  onTabChange,
  data,
}) {
  return (
    <Card sx={cardSx}>
      <CardContent sx={contentSx}>
        <SectionTitle icon={<Briefcase size={18} />} title="Dettagli Azienda" />

        <Tabs
          value={tab}
          onChange={(e, v) => onTabChange(v)}
          sx={{
            mb: 2,
            minHeight: 40,
            "& .MuiTab-root": {
              minHeight: 40,
              textTransform: "none",
              fontSize: 13,
              fontWeight: 700,
            },
          }}
        >
          <Tab label="Anagrafica" />
          <Tab label="Dati Finanziari" />
        </Tabs>

        {tab === 0 && (
          <Stack spacing={1.75}>
            <KvRow theme={theme} Icon={MapPin} label="Sede Legale" value={data.anagrafica.sedeLegale} alignRight />
            <Divider />
            <KvRow theme={theme} Icon={Hash} label="Forma Giuridica" value={data.anagrafica.formaGiuridica} />
            <Divider />
            <KvRow theme={theme} Icon={BarChart2} label="Settore" value={data.anagrafica.settore} alignRight />
            <Divider />
            <KvRow theme={theme} Icon={Calendar} label="Anno Fondazione" value={data.anagrafica.annoFondazione} />
          </Stack>
        )}

        {tab === 1 && (
          <Stack spacing={1.75}>
            <KvRow theme={theme} Icon={Users} label="Dipendenti" value={data.datiFinanziari.dipendenti} />
            <Divider />
            <KvRow theme={theme} Icon={DollarSign} label="Fatturato" value={data.datiFinanziari.fatturato} />
            <Divider />
            <KvRow theme={theme} Icon={TrendingUp} label="Utile Netto" value="€180.000" />
            <Divider />
            <KvRow theme={theme} Icon={Briefcase} label="Totale Attivo" value="€800.000" />
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}